"use client"

const ProcessSection = () => {
  const processSteps = [
    {
      id: 1,
      title: "Discovery Call",
      description: "We understand your business goals, challenges, and target audience.",
      icon: "🔍",
      color: "#6366f1",
    },
    {
      id: 2,
      title: "Strategy Creation",
      description: "Our team crafts a custom marketing plan tailored for you.",
      icon: "📋",
      color: "#8b5cf6",
    },
    {
      id: 3,
      title: "Campaign Execution",
      description: "We implement campaigns with precision and creativity.",
      icon: "🚀",
      color: "#06b6d4",
    },
    {
      id: 4,
      title: "Performance Tracking",
      description: "Monitor KPIs through detailed reports.",
      icon: "📊",
      color: "#10b981",
    },
    {
      id: 5,
      title: "Continuous Optimization",
      description: "Regular updates to maximize ROI.",
      icon: "⚡",
      color: "#f59e0b",
    },
  ]

  return (
    <section className="py-5" style={{ backgroundColor: "#f8fafc" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center">
            <div
              className="d-inline-block px-4 py-2 mb-4"
              style={{
                background: "linear-gradient(45deg, #6366f1, #8b5cf6)",
                borderRadius: "50px",
                color: "white",
                fontSize: "1.5rem",
                fontWeight: "600",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              Our Process
            </div>
            <h3
              className="display-4 fw-bold"
              style={{
                color: "#1e293b",
                letterSpacing: "-0.02em",
                fontSize : "40px"
              }}
            >
              Drive Your Growth with Our Proven Method
            </h3>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12">
            <div className="position-relative">
              {/* Desktop Hexagonal Flow */}
              <div className="d-none d-lg-block">
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    gap: "30px",
                    padding: "60px 0",
                  }}
                >
                  {processSteps.map((step, index) => (
                    <div key={step.id} className="position-relative">
                      <div
                        className="text-center"
                        style={{
                          width: "260px",
                          height: "320px",
                          position: "relative",
                          cursor: "pointer",
                          transition: "all 0.4s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05) translateY(-10px)"
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1) translateY(0)"
                        }}
                      >
                        <div
                          style={{
                            width: "180px",
                            height: "180px",
                            background: `linear-gradient(135deg, ${step.color}20, ${step.color}40)`,
                            clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
                            position: "absolute",
                            top: "0",
                            left: "50%",
                            transform: "translateX(-50%)",
                            border: `3px solid ${step.color}`,
                            boxShadow: `0 15px 40px ${step.color}30`,
                          }}
                        />

                        {/* Step Number */}
                        <div
                          className="position-absolute d-flex align-items-center justify-content-center"
                          style={{
                            top: "20px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "50px",
                            height: "50px",
                            background: step.color,
                            borderRadius: "50%",
                            color: "white",
                            fontSize: "1.5rem",
                            fontWeight: "bold",
                            zIndex: 3,
                            boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
                          }}
                        >
                          {step.id}
                        </div>

                        {/* Icon */}
                        <div
                          className="position-absolute"
                          style={{
                            top: "70px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            fontSize: "3rem",
                            zIndex: 3,
                            filter: "drop-shadow(2px 2px 8px rgba(0,0,0,0.2))",
                          }}
                        >
                          {step.icon}
                        </div>

                        <div
                          className="position-absolute"
                          style={{
                            bottom: "0",
                            left: "0",
                            right: "0",
                            height: "120px",
                            background: "rgba(255, 255, 255, 0.95)",
                            backdropFilter: "blur(15px)",
                            borderRadius: "20px",
                            padding: "20px 15px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                            border: `2px solid ${step.color}20`,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <h4
                            className="fw-bold mb-2"
                            style={{
                              color: step.color,
                              fontSize: "2rem",
                              lineHeight: "1.3",
                            }}
                          >
                            {step.title}
                          </h4>
                          <p
                            style={{
                              color: "#4b5563",
                              lineHeight: "1.4",
                              fontSize: "1.2rem",
                              margin: 0,
                            }}
                          >
                            {step.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Mobile/Tablet Stacked Design */}
              <div className="d-lg-none">
                <div className="row g-4">
                  {processSteps.map((step, index) => (
                    <div key={step.id} className="col-12 col-md-6">
                      <div
                        className="position-relative p-4 h-100"
                        style={{
                          background: "rgba(255, 255, 255, 0.95)",
                          backdropFilter: "blur(15px)",
                          borderRadius: "25px",
                          border: `3px solid ${step.color}`,
                          boxShadow: `0 15px 40px ${step.color}30`,
                          transition: "all 0.3s ease",
                          minHeight: "200px",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-5px)"
                          e.currentTarget.style.boxShadow = `0 20px 50px ${step.color}40`
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)"
                          e.currentTarget.style.boxShadow = `0 15px 40px ${step.color}30`
                        }}
                      >
                        {/* Step Badge */}
                        <div
                          className="position-absolute d-flex align-items-center justify-content-center"
                          style={{
                            top: "-15px",
                            right: "20px",
                            width: "40px",
                            height: "40px",
                            background: step.color,
                            borderRadius: "50%",
                            color: "white",
                            fontSize: "1.2rem",
                            fontWeight: "bold",
                            boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                          }}
                        >
                          {step.id}
                        </div>

                        <div className="d-flex align-items-start">
                          <div
                            className="me-4"
                            style={{
                              fontSize: "3rem",
                              filter: "drop-shadow(2px 2px 8px rgba(0,0,0,0.1))",
                            }}
                          >
                            {step.icon}
                          </div>
                          <div className="flex-grow-1">
                            <h5
                              className="fw-bold mb-3"
                              style={{
                                color: step.color,
                                fontSize: "1.4rem",
                              }}
                            >
                              {step.title}
                            </h5>
                            <p
                              style={{
                                color: "#4b5563",
                                lineHeight: "1.6",
                                fontSize: "1rem",
                                margin: 0,
                              }}
                            >
                              {step.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row justify-content-center mt-5">
          <div className="col-lg-8 text-center">
            <div
              className="p-5"
              style={{
                background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                borderRadius: "30px",
                boxShadow: "0 20px 60px rgba(99, 102, 241, 0.3)",
              }}
            >
              <h3
                className="mb-4"
                style={{
                  color: "#ffffff",
                  fontSize: "1.8rem",
                  fontWeight: "600",
                }}
              >
                Ready to Transform Your Business?
              </h3>
              <button
                className="btn btn-lg px-5 py-3 fw-bold me-3 mb-3"
                style={{
                  background: "white",
                  border: "none",
                  borderRadius: "50px",
                  color: "#6366f1",
                  fontSize: "1.1rem",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px) scale(1.05)"
                  e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.3)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)"
                  e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.2)"
                }}
              >
                Get Started Now
              </button>
              <button
                className="btn btn-lg px-5 py-3 fw-bold mb-3"
                style={{
                  background: "transparent",
                  border: "2px solid white",
                  borderRadius: "50px",
                  color: "white",
                  fontSize: "1.1rem",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)"
                  e.currentTarget.style.transform = "translateY(-2px)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent"
                  e.currentTarget.style.transform = "translateY(0)"
                }}
              >
                Learn More
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  )
}

export default ProcessSection
